import { useProjectParams } from '@hooks/useProjectParams';
import { useProjectData } from 'hooks/useProjectData';
import { ProjectPageLayout } from 'pages/Project/Common/Layouts/ProjectPageLayout';

import { useMemo } from 'react';

import { ContractModal } from './ContractModal';

export const ContractUpload = () => {
    const { id: projectId, methodology } = useProjectParams();

    const { projectData } = useProjectData(projectId);

    const breadCrumbsItems = useMemo(
        () => [
            {
                label: projectData?.name,
                href: `/projects/${methodology}/${projectId}`,
            },
        ],
        [methodology, projectData?.name, projectId],
    );

    return (
        <ProjectPageLayout title="Создание договора" breadCrumbsItems={breadCrumbsItems}>
            <ContractModal projectId={projectId} />
        </ProjectPageLayout>
    );
};

ContractUpload.displayName = 'ContractUpload';
